'use client';

import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
import { PhoneInputContextValue, usePhoneInput } from './context';
export interface PhoneInputModuleProps {
  children: (phone: PhoneInputContextValue) => ReactNode;
}
export function PhoneInputModule(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const context = usePhoneInput();
  let t1;
  if ($[0] !== children || $[1] !== context) {
    t1 = children(context);
    $[0] = children;
    $[1] = context;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <>{t1}</>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}